import type {
    AiMessageVettingAgent,
    AiMessageVettingAgentPayload,
    AiMessageVettingAgentsClientInterface,
    GetAiMessageVettingAgentsParams,
    GetAiMessageVettingAgentMessageStandardCountsResponse,
    GetAiSuggestionsParams,
} from './aiMessageVettingAgentsClient.types';
import type { CursorPaginationResponse } from '~/services/api';
import type { AxiosPromise } from 'axios';
import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';

export default class CorporateAiMessageVettingAgentsClient
    extends BaseClient
    implements AiMessageVettingAgentsClientInterface
{
    constructor(private teamId: number) {
        super();
    }

    getAiMessageVettingAgents(
        params?: GetAiMessageVettingAgentsParams
    ): AxiosPromise<CursorPaginationResponse<AiMessageVettingAgent>> {
        const url = `/api/v3/teams/${this.teamId}/ai-message-vetting-agents`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getAiMessageVettingAgent(agentId: number): AxiosPromise<AiMessageVettingAgent> {
        const url = `/api/v3/teams/${this.teamId}/ai-message-vetting-agents/${agentId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createAiMessageVettingAgent(data: AiMessageVettingAgentPayload): AxiosPromise<AiMessageVettingAgent> {
        const url = `/api/v3/teams/${this.teamId}/ai-message-vetting-agents`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateAiMessageVettingAgent(
        agentId: number,
        data: AiMessageVettingAgentPayload
    ): AxiosPromise<AiMessageVettingAgent> {
        const url = `/api/v3/teams/${this.teamId}/ai-message-vetting-agents/${agentId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteAiMessageVettingAgent(agentId: number): AxiosPromise<void> {
        const url = `/api/v3/teams/${this.teamId}/ai-message-vetting-agents/${agentId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getAiMessageVettingAgentMessageStandardCounts(params: {
        ai_message_vetting_agent_ids: number[];
    }): AxiosPromise<GetAiMessageVettingAgentMessageStandardCountsResponse> {
        const url = `/api/v3/teams/${this.teamId}/ai-message-vetting-agents/message-standard-counts`;
        return this.makeCoreApiRequest(url, 'post', params);
    }

    getInstructionsSuggestions(
        params: GetAiSuggestionsParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<{ data: string[] }> {
        const url = `/api/v3/teams/${this.teamId}/ai-message-vetting-agents/suggest-prompt-improvements`;
        return this.makeCoreApiRequest(url, 'post', params, null, config);
    }
}
